import { render, staticRenderFns } from "./addReceivableStatement.vue?vue&type=template&id=f74f6372&scoped=true&"
import script from "./addReceivableStatement.vue?vue&type=script&lang=js&"
export * from "./addReceivableStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74f6372",
  null
  
)

export default component.exports